// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`MoneyField test Match con el snapshot 1`] = `
<div class="container">
    <div class="container float-container"><label for="text-2" class=""></label> <input id="text-2" name="text-2" type="search" placeholder="" pattern="[0-9]*" inputmode="numeric" class="">
        <!---->
        <!---->
    </div>
</div>
`;
